import React from 'react'
import { invert } from 'lodash'
import accountUtils from '../../utils/account/accountUtils'
import store from '../../store/configureStore'
import { getInsTokenModules } from '../../routes/unauthenticated/Onboarding/insTokenDuck'
import { useSendUserData } from '../../utils/hooks/fullstory/useSendUserData'

// They are allowed on Payment
const allowedOnPayment = (user, pathname) =>
  accountUtils.mustUpdatePayment(user) && pathname !== '/app/update-payment'

// They are not allowed on Payment
const notAllowedOnPayment = (user, pathname) =>
  !accountUtils.mustUpdatePayment(user) && pathname === '/app/update-payment'

// They are allowed to Recreate their Subscription
const allowedOnRecreateSubscription = (user, pathname) =>
  accountUtils.mustRecreateSubscription(user) && pathname !== '/app/recreate-subscription'

// They are not allowed to Recreate Subscription
const notAllowedOnRecreateSubscription = (user, pathname) =>
  !accountUtils.mustRecreateSubscription(user) && pathname === '/app/recreate-subscription'

const linkToModules = {
  '/app/dashboard': 'Home',
  '/app/search': 'Career-Paths',
  '/app/tuition': 'Tuition',
  '/app/scholarships': 'Scholarships',
  '/app/jobs': 'Job-Board',
  '/app/personality-assessment': 'Personality',
  '/app/interests-profiler': 'Work-Profiler',
}

const onlyIfAuthenticated = WrappedComponent => props => {
  const {
    currentUser: { user },
  } = store.getState()
  const { pathname } = props.location // eslint-disable-line
  const allowedModules = getInsTokenModules(store.getState())

  useSendUserData(user)

  // Check if user exists
  const userExists = accountUtils.userExists(user)

  // If no user, automatically take them to login
  if (!userExists) {
    props.history.push('/login') // eslint-disable-line
    return null
  }

  // If there's a user and they can process payment, take them to update their payment
  else if (userExists && allowedOnPayment(user, pathname)) {
    props.history.push('/app/update-payment')
    return null
  }

  // If there's a user and they can't update payment, keep them on profile
  else if (userExists && notAllowedOnPayment(user, pathname)) {
    props.history.push('/app/profile')
    return null
  }

  // User exists and allowed to renew their cancelled Subscription
  else if (userExists && allowedOnRecreateSubscription(user, pathname)) {
    props.history.push('/app/recreate-subscription')
    return null
  }

  // User exists and not allowed to renew cancelled subscription
  else if (userExists && notAllowedOnRecreateSubscription(user, pathname)) {
    props.history.push('/app/profile')
    return null
  }

  // Needs to finish onboarding
  else if (userExists && !user.stripe_customer_id && !user.insToken && pathname !== '/onboarding') {
    props.history.push('/onboarding')
    return null
  }

  // User exists and can NOT access Parent dashboard
  else if (
    userExists &&
    !accountUtils.isAbleToBeOnParentDashboard(user) &&
    pathname === '/app/parent'
  ) {
    props.history.push('/app/dashboard')
    return null
  }

  // User exists and can NOT access Admin dashboard
  else if (
    userExists &&
    !accountUtils.isAbleToBeOnAdminDashboard(user) &&
    pathname === '/app/admin'
  ) {
    props.history.push('/app/dashboard')
    return null
  }

  // User exists and can NOT access current path
  else if (
    userExists &&
    allowedModules &&
    allowedModules.indexOf(linkToModules[pathname]) === -1 &&
    linkToModules[pathname] !== undefined
  ) {
    props.history.push(invert(linkToModules)[allowedModules[0]])
    return null
  }

  // User exists and can NOT access Demo
  else if (userExists && !accountUtils.isAbleToAccessDemo(user) && pathname === '/app/demo') {
    props.history.push('/app/dashboard')
    return null
  }

  return <WrappedComponent {...props} />
}

export default onlyIfAuthenticated



// WEBPACK FOOTER //
// ./src/components/hocs/onlyIfAuthenticated.js